import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { OrderCancellationSingleRequestImpl } from "../model/impl/OrderCancellationSingleRequestImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";
import { Relationship } from "../model/impl/Relationship";

export class OrderDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();
  public static FID__CANCEL_DTS = 202;

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  /**
   *	Set by the system when decoding
   **/

  public encode(encodable: CubiqTS.OrderDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.encodeInner(encodable, streamout, true, true, true);
  }

  public isPropertySet(val: any): boolean {
    return !(val === null || val === undefined);
  }

  public encodeInner(
    encodable: CubiqTS.OrderDataImpl,
    streamout: CubiqTS.ByteBuffer,
    encodeSibling: boolean,
    encodeChild: boolean,
    encodeParent: boolean,
  ): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Primitive encoding*/
    this.baseEncoder.writeStartFid(75, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(75),
      false,
      encodable.isPrivate,
      streamout,
    );
    this.baseEncoder.writeEndFid(75, streamout);

    /*Object encoding*/
    if (encodable.clientIntent != null) {
      this.baseEncoder.writeStartFid(24, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(24),
        false,
        encodable.clientIntent,
        streamout,
      );
      this.baseEncoder.writeEndFid(24, streamout);
    }
    /*Object encoding*/
    if (encodable.clOrdLinkID != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(15),
        false,
        encodable.clOrdLinkID,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.settleTenor != null) {
      this.baseEncoder.writeStartFid(48, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(48),
        false,
        encodable.settleTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(48, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardDetails != null) {
      this.baseEncoder.writeStartFid(91, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(91),
        true,
        encodable.forwardDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(91, streamout);
    }
    /*Object encoding*/
    if (encodable.activationDts != null) {
      this.baseEncoder.writeStartFid(42, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(42),
        false,
        encodable.activationDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(42, streamout);
    }
    /*Object encoding*/
    if (encodable.expiryAlias != null) {
      this.baseEncoder.writeStartFid(41, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(41),
        false,
        encodable.expiryAlias,
        streamout,
      );
      this.baseEncoder.writeEndFid(41, streamout);
    }
    /*Object encoding*/
    if (encodable.clientTraderName != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(9),
        false,
        encodable.clientTraderName,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivLeavesQty != null) {
      this.baseEncoder.writeStartFid(29, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(29),
        false,
        encodable.usdEquivLeavesQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(29, streamout);
    }
    /*Primitive encoding*/

    this.baseEncoder.writeStartFid(47, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(47),
      false,
      encodable.isOddFixingDateFg,
      streamout,
    );
    this.baseEncoder.writeEndFid(47, streamout);

    /*Object encoding*/
    if (encodable.trailingStopDetails != null) {
      this.baseEncoder.writeStartFid(96, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(96),
        true,
        encodable.trailingStopDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(96, streamout);
    }
    /*Object encoding*/
    if (encodable.requestTrackingType != null) {
      this.baseEncoder.writeStartFid(53, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(53),
        false,
        encodable.requestTrackingType,
        streamout,
      );
      this.baseEncoder.writeEndFid(53, streamout);
    }
    /*Object encoding*/
    if (encodable.executionType != null) {
      this.baseEncoder.writeStartFid(38, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(38),
        false,
        encodable.executionType,
        streamout,
      );
      this.baseEncoder.writeEndFid(38, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyParameters != null) {
      this.baseEncoder.writeStartFid(98, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(98),
        false,
        encodable.strategyParameters,
        streamout,
      );
      this.baseEncoder.writeEndFid(98, streamout);
    }
    /*Object encoding*/
    if (encodable.targetDeskId != null) {
      this.baseEncoder.writeStartFid(89, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(89),
        false,
        encodable.targetDeskId,
        streamout,
      );
      this.baseEncoder.writeEndFid(89, streamout);
    }
    /*Object encoding*/
    if (encodable.algoStrategyName != null) {
      this.baseEncoder.writeStartFid(35, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(35),
        false,
        encodable.algoStrategyName,
        streamout,
      );
      this.baseEncoder.writeEndFid(35, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingSourceCd != null) {
      this.baseEncoder.writeStartFid(46, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(46),
        false,
        encodable.fixingSourceCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(46, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseCode != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(22),
        false,
        encodable.nonBaseCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.executionInstruction != null) {
      this.baseEncoder.writeStartFid(37, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(37),
        false,
        encodable.executionInstruction,
        streamout,
      );
      this.baseEncoder.writeEndFid(37, streamout);
    }
    /*Object encoding*/
    if (encodable.parentRelationship != null) {
      this.baseEncoder.writeStartFid(82, streamout);
      let r: Relationship = encodable.parentRelationship;
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(82),
        true,
        encodable.parentRelationship,
        streamout,
      );
      let parentEncodable: boolean = encodeParent && r.order != null;
      this.baseEncoder.writeString(parentEncodable ? "Y" : "N", streamout);
      if (parentEncodable) this.encodeInner(r.order, streamout, true, false, true);
      this.baseEncoder.writeEndFid(82, streamout);
    }
    /*Object encoding*/
    if (encodable.vwapAllInRt != null) {
      this.baseEncoder.writeStartFid(80, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(80),
        false,
        encodable.vwapAllInRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(80, streamout);
    }
    /*Object encoding*/
    if (encodable.leavesSettleQty != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(28),
        false,
        encodable.leavesSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.requestedOrderType != null) {
      this.baseEncoder.writeStartFid(52, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(52),
        false,
        encodable.requestedOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(52, streamout);
    }
    /*Object encoding*/
    if (encodable.siblingRelationship != null) {
      this.baseEncoder.writeStartFid(83, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(83),
        true,
        encodable.siblingRelationship,
        streamout,
      );
      if (encodeSibling) {
        this.baseEncoder.writeString(
          this.isPropertySet(encodable.siblingRelationship.order) ? "Y" : "N",
          streamout,
        );
        if (this.isPropertySet(encodable.siblingRelationship.order))
          this.encodeInner(encodable.siblingRelationship.order, streamout, false, true, false);
      } else {
        this.baseEncoder.writeString("N", streamout);
      }
      this.baseEncoder.writeEndFid(83, streamout);
    }
    /*Object encoding*/
    if (encodable.trackingSide != null) {
      this.baseEncoder.writeStartFid(55, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(55),
        false,
        encodable.trackingSide,
        streamout,
      );
      this.baseEncoder.writeEndFid(55, streamout);
    }
    /*Object encoding*/
    if (encodable.monitoringOrderType != null) {
      this.baseEncoder.writeStartFid(36, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(36),
        false,
        encodable.monitoringOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(36, streamout);
    }
    /*Primitive encoding*/
    this.baseEncoder.writeStartFid(70, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(70),
      false,
      encodable.isAutoEligible,
      streamout,
    );
    this.baseEncoder.writeEndFid(70, streamout);

    /*Object encoding*/
    if (encodable.childRelationships != null) {
      this.baseEncoder.writeStartFid(81, streamout);
      this.baseEncoder.writeInt(encodable.childRelationships.length, streamout);
      encodable.childRelationships.forEach((r: CubiqTS.Relationship) => {
        this.baseEncoder.writeObject(
          false,
          OrderDataImplEncoder.fidTypeMap.get(81),
          true,
          r,
          streamout,
        );
        let childEncodable: boolean = encodeChild && r.order != null;
        this.baseEncoder.writeString(!childEncodable ? "N" : "Y", streamout);
        if (childEncodable) this.encodeInner(r.order, streamout, true, true, false);
      });
      this.baseEncoder.writeEndFid(81, streamout);
    }
    /*Primitive encoding*/

    this.baseEncoder.writeStartFid(74, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(74),
      false,
      encodable.isInvertedOrderFg,
      streamout,
    );
    this.baseEncoder.writeEndFid(74, streamout);

    /*Primitive encoding*/

    this.baseEncoder.writeStartFid(76, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(76),
      false,
      encodable.isRateReverseEngineeringFg,
      streamout,
    );
    this.baseEncoder.writeEndFid(76, streamout);

    /*Object encoding*/
    if (encodable.activationAlias != null) {
      this.baseEncoder.writeStartFid(43, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(43),
        false,
        encodable.activationAlias,
        streamout,
      );
      this.baseEncoder.writeEndFid(43, streamout);
    }
    /*Object encoding*/
    if (encodable.orderErrors != null) {
      this.baseEncoder.writeStartFid(78, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(78),
        true,
        encodable.orderErrors,
        streamout,
      );
      this.baseEncoder.writeEndFid(78, streamout);
    }
    /*Object encoding*/
    if (encodable.swapDetails != null) {
      this.baseEncoder.writeStartFid(94, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(94),
        true,
        encodable.swapDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(94, streamout);
    }
    /*Object encoding*/
    if (encodable.gammaRungId != null) {
      this.baseEncoder.writeStartFid(84, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(84),
        false,
        encodable.gammaRungId,
        streamout,
      );
      this.baseEncoder.writeEndFid(84, streamout);
    }
    /*Object encoding*/
    if (encodable.lastFillDetails != null) {
      this.baseEncoder.writeStartFid(92, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(92),
        true,
        encodable.lastFillDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(92, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerDetails != null) {
      this.baseEncoder.writeStartFid(95, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(95),
        true,
        encodable.triggerDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(95, streamout);
    }
    /*Object encoding*/
    if (encodable.rateSourceCd != null) {
      this.baseEncoder.writeStartFid(69, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(69),
        false,
        encodable.rateSourceCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(69, streamout);
    }
    /*Object encoding*/
    if (encodable.suspensionDetails != null) {
      this.baseEncoder.writeStartFid(93, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(93),
        true,
        encodable.suspensionDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(93, streamout);
    }
    /*Object encoding*/
    if (encodable.creditRevalDetails != null) {
      this.baseEncoder.writeStartFid(90, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(90),
        true,
        encodable.creditRevalDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(90, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(13),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.clientName != null) {
      this.baseEncoder.writeStartFid(125, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(125),
        false,
        encodable.clientName,
        streamout,
      );
      this.baseEncoder.writeEndFid(125, streamout);
    }
    /*Object encoding*/
    if (encodable.orderType != null) {
      this.baseEncoder.writeStartFid(34, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(34),
        false,
        encodable.orderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(34, streamout);
    }
    /*Object encoding*/
    if (encodable.product != null) {
      this.baseEncoder.writeStartFid(32, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(32),
        false,
        encodable.product,
        streamout,
      );
      this.baseEncoder.writeEndFid(32, streamout);
    }
    /*Object encoding*/
    if (encodable.expiryDts != null) {
      this.baseEncoder.writeStartFid(39, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(39),
        false,
        encodable.expiryDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(39, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyId != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(16),
        false,
        encodable.strategyId,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedCode != null) {
      this.baseEncoder.writeStartFid(23, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(23),
        false,
        encodable.fixedCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(23, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCode != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(21),
        false,
        encodable.baseCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.leavesQty != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(27),
        false,
        encodable.leavesQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.slippage != null) {
      this.baseEncoder.writeStartFid(44, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(44),
        false,
        encodable.slippage,
        streamout,
      );
      this.baseEncoder.writeEndFid(44, streamout);
    }
    /*Object encoding*/
    if (encodable.settleDate != null) {
      this.baseEncoder.writeStartFid(49, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(49),
        false,
        encodable.settleDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(49, streamout);
    }
    /*Object encoding*/
    if (encodable.txTime != null) {
      this.baseEncoder.writeStartFid(85, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(85),
        false,
        encodable.txTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(85, streamout);
    }
    /*Object encoding*/
    if (encodable.expiryType != null) {
      this.baseEncoder.writeStartFid(40, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(40),
        false,
        encodable.expiryType,
        streamout,
      );
      this.baseEncoder.writeEndFid(40, streamout);
    }
    /*Object encoding*/
    if (encodable.settleQty != null) {
      this.baseEncoder.writeStartFid(26, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(26),
        false,
        encodable.settleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(26, streamout);
    }
    /*Object encoding*/
    if (encodable.fillState != null) {
      this.baseEncoder.writeStartFid(67, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(67),
        false,
        encodable.fillState,
        streamout,
      );
      this.baseEncoder.writeEndFid(67, streamout);
    }
    /*Object encoding*/
    if (encodable.orderQty != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(25),
        false,
        encodable.orderQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.entryDts != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(17),
        false,
        encodable.entryDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.modifyDts != null) {
      this.baseEncoder.writeStartFid(117, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(117),
        false,
        encodable.modifyDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(117, streamout);
    }
    /*Object encoding*/
    if (encodable.deskId != null) {
      this.baseEncoder.writeStartFid(86, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(86),
        false,
        encodable.deskId,
        streamout,
      );
      this.baseEncoder.writeEndFid(86, streamout);
    }
    /*Object encoding*/
    if (encodable.clOrdID != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(14),
        false,
        encodable.clOrdID,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.orderState != null) {
      this.baseEncoder.writeStartFid(33, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(33),
        false,
        encodable.orderState,
        streamout,
      );
      this.baseEncoder.writeEndFid(33, streamout);
    }
    /*Object encoding*/
    if (encodable.comments2 != null) {
      this.baseEncoder.writeStartFid(31, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(31),
        false,
        encodable.comments2,
        streamout,
      );
      this.baseEncoder.writeEndFid(31, streamout);
    }
    /*Object encoding*/
    if (encodable.trackingRt != null) {
      this.baseEncoder.writeStartFid(60, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(60),
        false,
        encodable.trackingRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(60, streamout);
    }
    /*Object encoding*/
    if (encodable.channelCd != null) {
      this.baseEncoder.writeStartFid(68, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(68),
        false,
        encodable.channelCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(68, streamout);
    }
    /*Primitive encoding*/

    this.baseEncoder.writeStartFid(77, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(77),
      false,
      encodable.isModifiable,
      streamout,
    );
    this.baseEncoder.writeEndFid(77, streamout);

    /*Primitive encoding*/
    this.baseEncoder.writeStartFid(112, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(112),
      false,
      encodable.stpHold,
      streamout,
    );
    this.baseEncoder.writeEndFid(112, streamout);

    /*Object encoding*/
    if (encodable.vwapSpotRt != null) {
      this.baseEncoder.writeStartFid(79, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(79),
        false,
        encodable.vwapSpotRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(79, streamout);
    }
    /*Object encoding*/
    if (encodable.comments1 != null) {
      this.baseEncoder.writeStartFid(30, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(30),
        false,
        encodable.comments1,
        streamout,
      );
      this.baseEncoder.writeEndFid(30, streamout);
    }
    /*Object encoding*/
    if (encodable.requestRt != null) {
      this.baseEncoder.writeStartFid(56, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(56),
        false,
        encodable.requestRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(56, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDate != null) {
      this.baseEncoder.writeStartFid(45, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(45),
        false,
        encodable.fixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(45, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupId != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(7),
        false,
        encodable.salesGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBranchCode != null) {
      this.baseEncoder.writeStartFid(97, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(97),
        false,
        encodable.clientBranchCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(97, streamout);
    }
    /*Object encoding*/
    if (encodable.salesMargin != null) {
      this.baseEncoder.writeStartFid(54, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(54),
        false,
        encodable.salesMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(54, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserCode != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(18),
        false,
        encodable.entryUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(10),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.accountName != null) {
      this.baseEncoder.writeStartFid(126, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(126),
        false,
        encodable.accountName,
        streamout,
      );
      this.baseEncoder.writeEndFid(126, streamout);
    }
    /*Object encoding*/
    if (encodable.clientIsTraderVisible != null) {
      this.baseEncoder.writeStartFid(128, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(128),
        false,
        encodable.clientIsTraderVisible,
        streamout,
      );
      this.baseEncoder.writeEndFid(128, streamout);
    }
    /*Object encoding*/
    if (encodable.clientSegment != null) {
      this.baseEncoder.writeStartFid(127, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(127),
        false,
        encodable.clientSegment,
        streamout,
      );
      this.baseEncoder.writeEndFid(127, streamout);
    }
    /*Object encoding*/
    if (encodable.transferUserId != null) {
      this.baseEncoder.writeStartFid(99, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(99),
        false,
        encodable.transferUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(99, streamout);
    }
    /*Object encoding*/
    if (encodable.cancelUserId != null) {
      this.baseEncoder.writeStartFid(113, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(113),
        false,
        encodable.cancelUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(113, streamout);
    }
    if (encodable.cancelDts != null) {
      this.baseEncoder.writeStartFid(OrderDataImplEncoder.FID__CANCEL_DTS, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(OrderDataImplEncoder.FID__CANCEL_DTS),
        false,
        encodable.cancelDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(OrderDataImplEncoder.FID__CANCEL_DTS, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserId != null) {
      this.baseEncoder.writeStartFid(101, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(101),
        false,
        encodable.entryUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(101, streamout);
    }
    /*Object encoding*/
    if (encodable.lockUserId != null) {
      this.baseEncoder.writeStartFid(102, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(102),
        false,
        encodable.lockUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(102, streamout);
    }
    /*Object encoding*/
    if (encodable.lockType != null) {
      this.baseEncoder.writeStartFid(103, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(103),
        false,
        encodable.lockType,
        streamout,
      );
      this.baseEncoder.writeEndFid(103, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivQty != null) {
      this.baseEncoder.writeStartFid(104, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(104),
        false,
        encodable.usdEquivQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(104, streamout);
    }
    /*primitive encoding*/
    this.baseEncoder.writeStartFid(105, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(105),
      false,
      encodable.isAboutToActivate,
      streamout,
    );
    this.baseEncoder.writeEndFid(105, streamout);

    /*primitive encoding*/
    this.baseEncoder.writeStartFid(106, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(106),
      false,
      encodable.isAboutToExpire,
      streamout,
    );
    this.baseEncoder.writeEndFid(106, streamout);

    /*primitive encoding*/
    this.baseEncoder.writeStartFid(107, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(107),
      false,
      encodable.isAboutToSuspend,
      streamout,
    );
    this.baseEncoder.writeEndFid(107, streamout);

    /*primitive encoding*/
    this.baseEncoder.writeStartFid(108, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(108),
      false,
      encodable.isActivatingOrder,
      streamout,
    );
    this.baseEncoder.writeEndFid(108, streamout);
    /*Object encoding*/
    if (encodable.executedQty != null) {
      this.baseEncoder.writeStartFid(109, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(109),
        false,
        encodable.executedQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(109, streamout);
    }
    /*Object encoding*/
    if (encodable.executedSettleQty != null) {
      this.baseEncoder.writeStartFid(110, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(110),
        false,
        encodable.executedSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(110, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivExecutedQty != null) {
      this.baseEncoder.writeStartFid(111, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(111),
        false,
        encodable.usdEquivExecutedQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(111, streamout);
    }
    /*Object encoding*/
    if (encodable.clientContactIds != null) {
      this.baseEncoder.writeStartFid(114, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(114),
        false,
        encodable.clientContactIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(114, streamout);
    }

    if (encodable.activationDetails != null) {
      this.baseEncoder.writeStartFid(115, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(115),
        true,
        encodable.activationDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(115, streamout);
    }
    if (encodable.expiryDetails != null) {
      this.baseEncoder.writeStartFid(116, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(116),
        true,
        encodable.expiryDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(116, streamout);
    }
    if (encodable.spotMarkupType != null) {
      this.baseEncoder.writeStartFid(118, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(118),
        false,
        encodable.spotMarkupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(118, streamout);
    }
    if (encodable.fwdMarkupValue != null) {
      this.baseEncoder.writeStartFid(119, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(119),
        false,
        encodable.fwdMarkupValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(119, streamout);
    }
    if (encodable.fwdMarkupType != null) {
      this.baseEncoder.writeStartFid(120, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(120),
        false,
        encodable.fwdMarkupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(120, streamout);
    }
    if (encodable.spotMarkupValue != null) {
      this.baseEncoder.writeStartFid(121, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(121),
        false,
        encodable.spotMarkupValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(121, streamout);
    }
    /*Object encoding*/
    if (encodable.tradesCount != null) {
      this.baseEncoder.writeStartFid(122, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(122),
        false,
        encodable.tradesCount,
        streamout,
      );
      this.baseEncoder.writeEndFid(122, streamout);
    }
    /*Object encoding*/
    if (encodable.clientTraderId != null) {
      this.baseEncoder.writeStartFid(123, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(123),
        false,
        encodable.clientTraderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(123, streamout);
    }
    /*Object encoding*/
    if (encodable.lastOwnerGroupId != null) {
      this.baseEncoder.writeStartFid(124, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(124),
        false,
        encodable.lastOwnerGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(124, streamout);
    }
    /*Object encoding*/
    if (encodable.counterPartyDetails != null) {
      this.baseEncoder.writeStartFid(129, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(129),
        true,
        encodable.counterPartyDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(129, streamout);
    }
    /*Object encoding*/
    if (encodable.clientIsTraderVisible != null) {
      this.baseEncoder.writeStartFid(130, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(130),
        false,
        encodable.clientStraightThroughProcessing,
        streamout,
      );
      this.baseEncoder.writeEndFid(130, streamout);
    }
    /*Object encoding*/
    if (encodable.siLockUserId != null) {
      this.baseEncoder.writeStartFid(131, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(131),
        false,
        encodable.siLockUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(131, streamout);
    }
    /*Object encoding*/
    if (encodable.isLoopActiveLeg != null) {
      this.baseEncoder.writeStartFid(132, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(132),
        false,
        encodable.isLoopActiveLeg,
        streamout,
      );
      this.baseEncoder.writeEndFid(132, streamout);
    }
    if (encodable.strategyType != null) {
      this.baseEncoder.writeStartFid(133, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(133),
        false,
        encodable.strategyType,
        streamout,
      );
      this.baseEncoder.writeEndFid(133, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBranchCd != null) {
      this.baseEncoder.writeStartFid(134, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(134),
        false,
        encodable.clientBranchCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(134, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCd != null) {
      this.baseEncoder.writeStartFid(135, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(135),
        false,
        encodable.clientCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(135, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCurrencyCd != null) {
      this.baseEncoder.writeStartFid(136, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(136),
        false,
        encodable.baseCurrencyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(136, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseCurrencyCd != null) {
      this.baseEncoder.writeStartFid(137, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(137),
        false,
        encodable.nonBaseCurrencyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(137, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSalesGroupId != null) {
      this.baseEncoder.writeStartFid(138, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(138),
        false,
        encodable.lastSalesGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(138, streamout);
    }
    /*Object encoding*/
    if (encodable.lastClientBranchCd != null) {
      this.baseEncoder.writeStartFid(139, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(139),
        false,
        encodable.lastClientBranchCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(139, streamout);
    }
    /*Object encoding*/
    if (encodable.lastBaseCurrencyCd != null) {
      this.baseEncoder.writeStartFid(140, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(140),
        false,
        encodable.lastBaseCurrencyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(140, streamout);
    }
    /*Object encoding*/
    if (encodable.lastNonBaseCurrencyCd != null) {
      this.baseEncoder.writeStartFid(141, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(141),
        false,
        encodable.lastNonBaseCurrencyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(141, streamout);
    }
    /*Object encoding*/
    if (encodable.customValues != null) {
      this.baseEncoder.writeStartFid(142, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(142),
        false,
        encodable.customValues,
        streamout,
      );
      this.baseEncoder.writeEndFid(142, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationData != null) {
      this.baseEncoder.writeStartFid(143, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(143),
        false,
        encodable.allocationData,
        streamout,
      );
      this.baseEncoder.writeEndFid(143, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDetails != null) {
      this.baseEncoder.writeStartFid(144, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(144),
        true,
        encodable.fixingDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(144, streamout);
    }
    if (encodable.pauseState != null) {
      this.baseEncoder.writeStartFid(145, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(145),
        false,
        encodable.pauseState,
        streamout,
      );
      this.baseEncoder.writeEndFid(145, streamout);
    }
    if (encodable.reqMargin != null) {
      this.baseEncoder.writeStartFid(146, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(146),
        false,
        encodable.reqMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(146, streamout);
    }
    if (encodable.reqMarginType != null) {
      this.baseEncoder.writeStartFid(147, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(147),
        false,
        encodable.reqMarginType,
        streamout,
      );
      this.baseEncoder.writeEndFid(147, streamout);
    }
    if (encodable.orderRevisionId != null) {
      this.baseEncoder.writeStartFid(148, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(148),
        false,
        encodable.orderRevisionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(148, streamout);
    }
    if (encodable.ownerGroupIds != null) {
      this.baseEncoder.writeStartFid(149, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(149),
        false,
        encodable.ownerGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(149, streamout);
    }
    if (encodable.lastOwnerGroupIds != null) {
      this.baseEncoder.writeStartFid(150, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(150),
        false,
        encodable.lastOwnerGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(150, streamout);
    }
    if (encodable.currencyPairIds != null) {
      this.baseEncoder.writeStartFid(151, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(151),
        false,
        encodable.currencyPairIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(151, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBranchHubCode != null) {
      this.baseEncoder.writeStartFid(152, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(152),
        false,
        encodable.clientBranchHubCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(152, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBranchHubName != null) {
      this.baseEncoder.writeStartFid(153, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(153),
        false,
        encodable.clientBranchHubName,
        streamout,
      );
      this.baseEncoder.writeEndFid(153, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserCd != null) {
      this.baseEncoder.writeStartFid(154, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(154),
        false,
        encodable.fillUserCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(154, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserName != null) {
      this.baseEncoder.writeStartFid(155, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(155),
        false,
        encodable.fillUserName,
        streamout,
      );
      this.baseEncoder.writeEndFid(155, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupName != null) {
      this.baseEncoder.writeStartFid(156, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(156),
        false,
        encodable.traderGroupName,
        streamout,
      );
      this.baseEncoder.writeEndFid(156, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupNm != null) {
      this.baseEncoder.writeStartFid(157, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(157),
        false,
        encodable.salesGroupNm,
        streamout,
      );
      this.baseEncoder.writeEndFid(157, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupBranchCd != null) {
      this.baseEncoder.writeStartFid(158, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(158),
        false,
        encodable.traderGroupBranchCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(158, streamout);
    }
    /*Primitive encoding*/
    this.baseEncoder.writeStartFid(159, streamout);
    this.baseEncoder.writeObject(
      false,
      OrderDataImplEncoder.fidTypeMap.get(159),
      false,
      encodable.isAggregateFillFg,
      streamout,
    );
    this.baseEncoder.writeEndFid(159, streamout);

    if (encodable.filledBaseAmt != null) {
      this.baseEncoder.writeStartFid(160, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(160),
        false,
        encodable.filledBaseAmt,
        streamout,
      );
      this.baseEncoder.writeEndFid(160, streamout);
    }
    if (encodable.currencyPairAndOwners != null) {
      this.baseEncoder.writeStartFid(161, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(161),
        false,
        encodable.currencyPairAndOwners,
        streamout,
      );
      this.baseEncoder.writeEndFid(161, streamout);
    }
    /*Object encoding*/
    if (encodable.algoProfileId != null) {
      this.baseEncoder.writeStartFid(162, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(162),
        false,
        encodable.algoProfileId,
        streamout,
      );
      this.baseEncoder.writeEndFid(162, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserNm != null) {
      this.baseEncoder.writeStartFid(163, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(163),
        false,
        encodable.entryUserNm,
        streamout,
      );
      this.baseEncoder.writeEndFid(163, streamout);
    }
    /*Object encoding*/
    if (encodable.clientBookingCd != null) {
      this.baseEncoder.writeStartFid(164, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(164),
        false,
        encodable.clientBookingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(164, streamout);
    }
    /*Object encoding*/
    if (encodable.accountBookingCd != null) {
      this.baseEncoder.writeStartFid(165, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(165),
        false,
        encodable.accountBookingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(165, streamout);
    }
    /*Object encoding*/
    if (encodable.passthroughParameters != null) {
      this.baseEncoder.writeStartFid(166, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(166),
        false,
        encodable.passthroughParameters,
        streamout,
      );
      this.baseEncoder.writeEndFid(166, streamout);
    }
    /*Object encoding*/
    if (encodable.externalMarketRt != null) {
      this.baseEncoder.writeStartFid(167, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(167),
        false,
        encodable.externalMarketRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(167, streamout);
    }
    /*Object encoding*/
    if (encodable.stpAggregationEnabled != null) {
      this.baseEncoder.writeStartFid(168, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(168),
        false,
        encodable.stpAggregationEnabled,
        streamout,
      );
      this.baseEncoder.writeEndFid(168, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateAccountCode != null) {
      this.baseEncoder.writeStartFid(169, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(169),
        false,
        encodable.alternateAccountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(169, streamout);
    }
    /*Object encoding*/
    if (encodable.modifyInAcceptanceFg != null) {
      this.baseEncoder.writeStartFid(170, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(170),
        false,
        encodable.modifyInAcceptanceFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(170, streamout);
    }

    if (encodable.detFillMarketRate != null) {
      this.baseEncoder.writeStartFid(171, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(171),
        false,
        encodable.detFillMarketRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(171, streamout);
    }

    if (encodable.detFillFwdPoints != null) {
      this.baseEncoder.writeStartFid(172, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(172),
        false,
        encodable.detFillFwdPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(172, streamout);
    }

    if (encodable.detFillNdfHorizonPts != null) {
      this.baseEncoder.writeStartFid(173, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(173),
        false,
        encodable.detFillNdfHorizonPts,
        streamout,
      );
      this.baseEncoder.writeEndFid(173, streamout);
    }

    if (encodable.detFillTradeableFg != null) {
      this.baseEncoder.writeStartFid(174, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(174),
        false,
        encodable.detFillTradeableFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(174, streamout);
    }

    if (encodable.detFillHorizonPtsTradeableFg != null) {
      this.baseEncoder.writeStartFid(175, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(175),
        false,
        encodable.detFillHorizonPtsTradeableFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(175, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateClientCode != null) {
      this.baseEncoder.writeStartFid(176, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(176),
        false,
        encodable.alternateClientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(176, streamout);
    }
    if (encodable.inflightInclusionState != null) {
      this.baseEncoder.writeStartFid(177, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(177),
        false,
        encodable.inflightInclusionState,
        streamout,
      );
      this.baseEncoder.writeEndFid(177, streamout);
    }

    if (encodable.creditRejectCd != null) {
      this.baseEncoder.writeStartFid(178, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(178),
        false,
        encodable.creditRejectCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(178, streamout);
    }
    /*Object encoding*/
    if (encodable.oboClient != null) {
      this.baseEncoder.writeStartFid(179, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(179),
        false,
        encodable.oboClient,
        streamout,
      );
      this.baseEncoder.writeEndFid(179, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(180, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(180),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(180, streamout);
    }

    /*Object encoding*/
    if (encodable.strategyRef != null) {
      this.baseEncoder.writeStartFid(181, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(181),
        false,
        encodable.strategyRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(181, streamout);
    }

    /*Object encoding*/
    if (encodable.orderRef != null) {
      this.baseEncoder.writeStartFid(182, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(182),
        false,
        encodable.orderRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(182, streamout);
    }

    /*Object encoding*/
    if (encodable.oboEntryUser != null) {
      this.baseEncoder.writeStartFid(183, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(183),
        false,
        encodable.oboEntryUser,
        streamout,
      );
      this.baseEncoder.writeEndFid(183, streamout);
    }

    /*Object encoding*/
    if (encodable.oboLockUser != null) {
      this.baseEncoder.writeStartFid(184, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(184),
        false,
        encodable.oboLockUser,
        streamout,
      );
      this.baseEncoder.writeEndFid(184, streamout);
    }

    /*Object encoding*/
    if (encodable.oboCancelUser != null) {
      this.baseEncoder.writeStartFid(185, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(185),
        false,
        encodable.oboCancelUser,
        streamout,
      );
      this.baseEncoder.writeEndFid(185, streamout);
    }

    /*Object encoding*/
    if (encodable.modifyUsers != null) {
      this.baseEncoder.writeStartFid(186, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderDataImplEncoder.fidTypeMap.get(186),
        false,
        encodable.modifyUsers,
        streamout,
      );
      this.baseEncoder.writeEndFid(186, streamout);
    }

    if (encodable.insidePrevisibilityFg != null) {
      this.baseEncoder.writeStartFid(187, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(187),
        false,
        encodable.insidePrevisibilityFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(187, streamout);
    }

    if (encodable.inboxReason != null) {
      this.baseEncoder.writeStartFid(188, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(188),
        false,
        encodable.inboxReason,
        streamout,
      );
      this.baseEncoder.writeEndFid(188, streamout);
    }

    if (encodable.inboxOpsId != null) {
      this.baseEncoder.writeStartFid(189, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(189),
        false,
        encodable.inboxOpsId,
        streamout,
      );
      this.baseEncoder.writeEndFid(189, streamout);
    }

    if (encodable.nettingId != null) {
      this.baseEncoder.writeStartFid(190, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(190),
        false,
        encodable.nettingId,
        streamout,
      );
      this.baseEncoder.writeEndFid(190, streamout);
    }

    if (encodable.autoForwardPricingFg != null) {
      this.baseEncoder.writeStartFid(191, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(191),
        false,
        encodable.autoForwardPricingFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(191, streamout);
    }

    if (encodable.hedgingMode != null) {
      this.baseEncoder.writeStartFid(192, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(192),
        false,
        encodable.hedgingMode,
        streamout,
      );
      this.baseEncoder.writeEndFid(192, streamout);
    }
    /*Object encoding*/
    if (encodable.hedgingRuleId != null) {
      this.baseEncoder.writeStartFid(193, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(193),
        false,
        encodable.hedgingRuleId,
        streamout,
      );
      this.baseEncoder.writeEndFid(193, streamout);
    }
    if (encodable.reqQuoteId != null) {
      this.baseEncoder.writeStartFid(194, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(194),
        false,
        encodable.reqQuoteId,
        streamout,
      );
      this.baseEncoder.writeEndFid(194, streamout);
    }
    if (encodable.fillNowOrderAmt != null) {
      this.baseEncoder.writeStartFid(195, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(195),
        false,
        encodable.fillNowOrderAmt,
        streamout,
      );
      this.baseEncoder.writeEndFid(195, streamout);
    }
    if (encodable.marketVwapSpotRt != null) {
      this.baseEncoder.writeStartFid(196, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(196),
        false,
        encodable.marketVwapSpotRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(196, streamout);
    }
    if (encodable.marketVwapAllInRt != null) {
      this.baseEncoder.writeStartFid(197, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(197),
        false,
        encodable.marketVwapAllInRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(197, streamout);
    }
    if (encodable.fwdNettingId != null) {
      this.baseEncoder.writeStartFid(198, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(198),
        false,
        encodable.fwdNettingId,
        streamout,
      );
      this.baseEncoder.writeEndFid(198, streamout);
    }
    /*Object encoding*/
    if (encodable.adjustedSettleTenor != null) {
      this.baseEncoder.writeStartFid(199, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(199),
        false,
        encodable.adjustedSettleTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(199, streamout);
    }

    if (encodable.previousFixingDts != null) {
      this.baseEncoder.writeStartFid(200, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(200),
        false,
        encodable.previousFixingDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(200, streamout);
    }

    if (encodable.previousTraderVisibilityOffset != null) {
      this.baseEncoder.writeStartFid(201, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(201),
        false,
        encodable.previousTraderVisibilityOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(201, streamout);
    }

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,OrderDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [75, "boolean"],
    [24, "com.bcdfx.model.OrderIntent"],
    [15, "java.lang.String"],
    [48, "com.bcdfx.model.Tenor"],
    [91, "com.bcdfx.model.event.lifecycle.fx.ForwardDetailsImpl"],
    [42, "java.util.Date"],
    [41, "java.lang.String"],
    [9, "java.lang.String"],
    [29, "java.math.BigDecimal"],
    [47, "boolean"],
    [96, "com.bcdfx.model.event.lifecycle.fx.TrailingStopDetailsImpl"],
    [53, "com.bcdfx.model.RequestTrackingType"],
    [38, "com.bcdfx.model.ExecutionType"],
    [98, "com.bcdfx.model.event.lifecycle.StrategyParameterImpl"],
    [89, "java.lang.Long"],
    [35, "java.lang.String"],
    [46, "java.lang.String"],
    [22, "java.lang.String"],
    [37, "com.bcdfx.model.FillSupport"],
    [82, "com.bcdfx.model.Relationship"],
    [80, "java.math.BigDecimal"],
    [28, "java.math.BigDecimal"],
    [52, "com.bcdfx.model.RequestOrderType"],
    [83, "com.bcdfx.model.Relationship"],
    [55, "com.bcdfx.model.RateSideType"],
    [36, "com.bcdfx.model.OrderType"],
    [70, "boolean"],
    [81, "com.bcdfx.model.Relationship"],
    [74, "boolean"],
    [76, "boolean"],
    [43, "java.lang.String"],
    [78, "com.bcdfx.broker.ErrorsImpl"],
    [94, "com.bcdfx.model.event.lifecycle.fx.SwapDetailsImpl"],
    [84, "java.lang.Long"],
    [92, "com.bcdfx.model.event.lifecycle.fx.LastFillDetailsImpl"],
    [95, "com.bcdfx.model.event.lifecycle.fx.TriggerDetails"],
    [69, "java.lang.String"],
    [93, "com.bcdfx.model.event.lifecycle.fx.SuspensionDetailsImpl"],
    [90, "com.bcdfx.model.event.lifecycle.fx.CreditRevalDetailsImpl"],
    [13, "java.lang.Long"],
    [1, "java.lang.String"],
    [34, "com.bcdfx.model.OrderType"],
    [32, "com.bcdfx.model.Product"],
    [39, "java.util.Date"],
    [16, "java.lang.Long"],
    [23, "java.lang.String"],
    [21, "java.lang.String"],
    [27, "java.math.BigDecimal"],
    [44, "java.lang.String"],
    [49, "java.util.Date"],
    [85, "java.util.Date"],
    [40, "com.bcdfx.model.OrderExpiryType"],
    [26, "java.math.BigDecimal"],
    [67, "com.bcdfx.model.FillState"],
    [25, "java.math.BigDecimal"],
    [17, "java.util.Date"],
    [86, "java.lang.Long"],
    [14, "java.lang.String"],
    [33, "com.bcdfx.api.model.OrderState"],
    [31, "java.lang.String"],
    [60, "java.math.BigDecimal"],
    [68, "java.lang.String"],
    [77, "boolean"],
    [79, "java.math.BigDecimal"],
    [30, "java.lang.String"],
    [56, "java.math.BigDecimal"],
    [45, "java.util.Date"],
    [7, "java.lang.Long"],
    [97, "java.lang.String"],
    [54, "java.math.BigDecimal"],
    [18, "java.lang.String"],
    [10, "java.lang.String"],
    [99, "java.lang.Long"],
    [101, "java.lang.Long"],
    [102, "java.lang.Long"],
    [103, "com.bcdfx.model.LockType"],
    [104, "java.math.BigDecimal"],
    [105, "boolean"],
    [106, "boolean"],
    [107, "boolean"],
    [108, "boolean"],
    [109, "java.math.BigDecimal"],
    [110, "java.math.BigDecimal"],
    [111, "java.math.BigDecimal"],
    [112, "boolean"],
    [113, "java.lang.Long"],
    [114, "java.lang.Long"],
    [115, "com.bcdfx.model.ActivationDetailsImpl"],
    [116, "com.bcdfx.model.ExpiryDetailsImpl"],
    [117, "java.util.Date"],
    [118, "com.bcdfx.model.MarkUpType"],
    [119, "java.math.BigDecimal"],
    [120, "com.bcdfx.model.MarkUpType"],
    [121, "java.math.BigDecimal"],
    [122, "java.lang.Long"],
    [123, "java.lang.Long"],
    [124, "java.lang.Long"],
    [125, "java.lang.String"],
    [126, "java.lang.String"],
    [127, "java.lang.String"],
    [128, "boolean"],
    [129, "com.bcdfx.model.CounterPartyDetailsImpl"],
    [130, "boolean"],
    [131, "java.lang.Long"],
    [132, "boolean"],
    [133, "com.bcdfx.model.StrategyType"],
    [134, "java.lang.String"],
    [135, "java.lang.String"],
    [136, "java.lang.String"],
    [137, "java.lang.String"],
    [138, "java.lang.Long"],
    [139, "java.lang.String"],
    [140, "java.lang.String"],
    [141, "java.lang.String"],
    [142, "com.bcdfx.model.CustomValueImpl"],
    [143, "com.bcdfx.model.event.lifecycle.fx.AllocationDataImpl"],
    [144, "com.bcdfx.model.event.lifecycle.fx.FixingDataImpl"],
    [145, "com.bcdfx.api.model.PauseState"],
    [146, "java.math.BigDecimal"],
    [147, "com.bcdfx.model.MarkUpType"],
    [148, "java.lang.Long"],
    [149, "java.lang.Long"],
    [150, "java.lang.Long"],
    [151, "java.lang.String"],
    [152, "java.lang.String"],
    [153, "java.lang.String"],
    [154, "java.lang.String"],
    [155, "java.lang.String"],
    [156, "java.lang.String"],
    [157, "java.lang.String"],
    [158, "java.lang.String"],
    [159, "boolean"],
    [160, "java.math.BigDecimal"],
    [161, "com.bcdfx.benchmarks.model.BenchmarkVisibilityPairAndOwnerImpl"],
    [162, "java.lang.String"],
    [163, "java.lang.String"],
    [164, "java.lang.String"],
    [165, "java.lang.String"],
    [166, "com.bcdfx.model.event.lifecycle.StrategyParameterImpl"],
    [167, "java.math.BigDecimal"],
    [168, "boolean"],
    [169, "java.lang.String"],
    [170, "boolean"],
    [171, "java.math.BigDecimal"],
    [172, "java.math.BigDecimal"],
    [173, "java.math.BigDecimal"],
    [174, "boolean"],
    [175, "boolean"],
    [176, "java.lang.String"],
    [177, "com.bcdfx.model.InflightInclusionState"],
    [178, "java.lang.Long"],
    [179, "java.lang.String"],
    [180, "java.lang.String"],
    [181, "java.lang.String"],
    [182, "java.lang.String"],
    [183, "java.lang.String"],
    [184, "java.lang.String"],
    [185, "java.lang.String"],
    [186, "java.lang.String"],
    [187, "boolean"],
    [188, "com.bcdfx.broker.ErrorsImpl"],
    [189, "java.lang.Long"],
    [190, "java.lang.String"],
    [191, "boolean"],
    [192, "com.bcdfx.model.HedgingModeType"],
    [193, "java.lang.Long"],
    [194, "java.lang.String"],
    [195, "java.math.BigDecimal"],
    [196, "java.math.BigDecimal"],
    [197, "java.math.BigDecimal"],
    [198, "java.lang.String"],
    [199, "com.bcdfx.model.Tenor"],
    [200, "java.util.Date"],
    [201, "java.lang.Long"],
    [OrderDataImplEncoder.FID__CANCEL_DTS, "java.util.Date"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: CubiqTS.OrderDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 75: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isPrivate = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 24: {
          /*Object encoding*/
          let val: CubiqTS.OrderIntent = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.OrderIntent",
            streamin,
          );
          encodable.clientIntent = <CubiqTS.OrderIntent>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clOrdLinkID = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 48: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.Tenor",
            streamin,
          );
          encodable.settleTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 91: {
          /*Object encoding*/
          let val: CubiqTS.ForwardDetails = this.baseEncoder.readObject(
            true,
            false,
            "ForwardDetailsImpl",
            streamin,
          );
          encodable.forwardDetails = <CubiqTS.ForwardDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 42: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.activationDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 41: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.expiryAlias = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientTraderName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 29: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.usdEquivLeavesQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 47: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isOddFixingDateFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 96: {
          /*Object encoding*/
          let val: CubiqTS.TrailingStopDetails = this.baseEncoder.readObject(
            true,
            false,
            "TrailingStopDetailsImpl",
            streamin,
          );
          encodable.trailingStopDetails = <CubiqTS.TrailingStopDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 53: {
          /*Object encoding*/
          let val: CubiqTS.RequestTrackingType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.RequestTrackingType",
            streamin,
          );
          encodable.requestTrackingType = <CubiqTS.RequestTrackingType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 38: {
          /*Object encoding*/
          let val: CubiqTS.ExecutionType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.ExecutionType",
            streamin,
          );
          encodable.executionType = <CubiqTS.ExecutionType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 98: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameterImpl> = this.baseEncoder.readObject(
            false,
            true,
            "Array",
            streamin,
          );
          encodable.strategyParameters = <Array<CubiqTS.StrategyParameterImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 89: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.targetDeskId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 35: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.algoStrategyName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 46: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.fixingSourceCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.nonBaseCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 37: {
          /*Object encoding*/
          let val: CubiqTS.FillSupport = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.FillSupport",
            streamin,
          );
          encodable.executionInstruction = <CubiqTS.FillSupport>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 82: {
          /*Object encoding*/
          let val: CubiqTS.Relationship = this.baseEncoder.readObject(
            true,
            false,
            "Relationship",
            streamin,
          );
          encodable.parentRelationship = <CubiqTS.Relationship>val;
          var dataPresent: string = this.baseEncoder.readString(streamin);
          if (dataPresent === "Y") {
            let d: CubiqTS.OrderDataImpl = <CubiqTS.OrderDataImpl>(
              this.baseEncoder.readObject(
                true,
                false,
                "com.bcdfx.model.event.lifecycle.fx.OrderDataImpl",
                streamin,
              )
            );
            val.order = d;
          }
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 80: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.vwapAllInRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.leavesSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 52: {
          /*Object encoding*/
          let val: CubiqTS.RequestOrderType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.RequestOrderType",
            streamin,
          );
          encodable.requestedOrderType = <CubiqTS.RequestOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 83: {
          /*Object encoding*/
          let val: CubiqTS.Relationship = this.baseEncoder.readObject(
            true,
            false,
            "Relationship",
            streamin,
          );
          encodable.siblingRelationship = <CubiqTS.Relationship>val;
          var siblingExists: string = this.baseEncoder.readString(streamin);
          if (siblingExists === "Y")
            encodable.siblingRelationship.order = <CubiqTS.OrderDataImpl>(
              this.baseEncoder.readObject(
                true,
                false,
                "com.bcdfx.model.event.lifecycle.fx.OrderDataImpl",
                streamin,
              )
            );
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 55: {
          /*Object encoding*/
          let val: CubiqTS.RateSideType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.RateSideType",
            streamin,
          );
          encodable.trackingSide = <CubiqTS.RateSideType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 36: {
          /*Object encoding*/
          let val: CubiqTS.OrderType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.OrderType",
            streamin,
          );
          encodable.monitoringOrderType = <CubiqTS.OrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 70: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isAutoEligible = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 81: {
          /*Object encoding*/
          let numChild: number = this.baseEncoder.readInt(streamin);
          let children: Array<CubiqTS.Relationship> = new Array<CubiqTS.Relationship>();
          for (let i = 0; i < numChild; ++i) {
            let val: CubiqTS.Relationship = this.baseEncoder.readObject(
              true,
              false,
              "Relationship",
              streamin,
            );
            children[i] = val;
            var dataAvailable: string = this.baseEncoder.readString(streamin);
            if (dataAvailable === "Y")
              val.order = <CubiqTS.OrderDataImpl>(
                this.baseEncoder.readObject(
                  true,
                  false,
                  "com.bcdfx.model.event.lifecycle.fx.OrderDataImpl",
                  streamin,
                )
              );
          }
          encodable.childRelationships = <Array<CubiqTS.Relationship>>children;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 74: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isInvertedOrderFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 76: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isRateReverseEngineeringFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 43: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.activationAlias = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 78: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(true, false, "Errors", streamin);
          encodable.orderErrors = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 94: {
          /*Object encoding*/
          let val: CubiqTS.SwapDetails = this.baseEncoder.readObject(
            true,
            false,
            "SwapDetailsImpl",
            streamin,
          );
          encodable.swapDetails = <CubiqTS.SwapDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 84: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.gammaRungId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 92: {
          /*Object encoding*/
          let val: CubiqTS.LastFillDetails = this.baseEncoder.readObject(
            true,
            false,
            "LastFillDetailsImpl",
            streamin,
          );
          encodable.lastFillDetails = <CubiqTS.LastFillDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 95: {
          /*Object encoding*/
          let val: CubiqTS.TriggerDetails = this.baseEncoder.readObject(
            true,
            false,
            "TriggerDetailsImpl",
            streamin,
          );
          encodable.triggerDetails = <CubiqTS.TriggerDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 69: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.rateSourceCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 93: {
          /*Object encoding*/
          let val: CubiqTS.SuspensionDetails = this.baseEncoder.readObject(
            true,
            false,
            "SuspensionDetailsImpl",
            streamin,
          );
          encodable.suspensionDetails = <CubiqTS.SuspensionDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 90: {
          /*Object encoding*/
          let val: CubiqTS.CreditRevalDetails = this.baseEncoder.readObject(
            true,
            false,
            "CreditRevalDetailsImpl",
            streamin,
          );
          encodable.creditRevalDetails = <CubiqTS.CreditRevalDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.orderId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 125: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 34: {
          /*Object encoding*/
          let val: CubiqTS.OrderType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.OrderType",
            streamin,
          );
          encodable.orderType = <CubiqTS.OrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 32: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.Product",
            streamin,
          );
          encodable.product = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 39: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.expiryDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.strategyId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 23: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.fixedCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.baseCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.leavesQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 44: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.slippage = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 49: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.settleDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 85: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.txTime = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 40: {
          /*Object encoding*/
          let val: CubiqTS.OrderExpiryType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.OrderExpiryType",
            streamin,
          );
          encodable.expiryType = <CubiqTS.OrderExpiryType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 26: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.settleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 67: {
          /*Object encoding*/
          let val: CubiqTS.FillState = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.FillState",
            streamin,
          );
          encodable.fillState = <CubiqTS.FillState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.orderQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.entryDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 117: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.modifyDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 86: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.deskId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clOrdID = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 33: {
          /*Object encoding*/
          let val: CubiqTS.OrderState = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.api.model.OrderState",
            streamin,
          );
          encodable.orderState = <CubiqTS.OrderState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 31: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.comments2 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 60: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.trackingRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 68: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.channelCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 77: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isModifiable = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 112: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.stpHold = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 79: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.vwapSpotRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 30: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.comments1 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 56: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.requestRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 45: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.fixingDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.salesGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 97: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientBranchCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 54: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.salesMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.entryUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 126: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.accountName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 99: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.transferUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 113: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.cancelUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 101: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.entryUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 102: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.lockUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 103: {
          /*Object encoding*/
          let val: CubiqTS.LockType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.LockType",
            streamin,
          );
          encodable.lockType = <CubiqTS.LockType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 104: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.usdEquivQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 105: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isAboutToActivate = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 106: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isAboutToExpire = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 107: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isAboutToSuspend = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 108: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isActivatingOrder = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 109: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.executedQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 110: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.executedSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 111: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.usdEquivExecutedQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 114: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            OrderDataImplEncoder.fidTypeMap.get(114),
            streamin,
          );
          encodable.clientContactIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 115: {
          /*Object encoding*/
          let val: CubiqTS.ActivationDetailsImpl = this.baseEncoder.readObject(
            true,
            false,
            OrderDataImplEncoder.fidTypeMap.get(115),
            streamin,
          );
          encodable.activationDetails = <CubiqTS.ActivationDetailsImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 116: {
          /*Object encoding*/
          let val: CubiqTS.ExpiryDetailsImpl = this.baseEncoder.readObject(
            true,
            false,
            OrderDataImplEncoder.fidTypeMap.get(116),
            streamin,
          );
          encodable.expiryDetails = <CubiqTS.ExpiryDetailsImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 118: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.MarkUpType",
            streamin,
          );
          encodable.spotMarkupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 119: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.fwdMarkupValue = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 120: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.MarkUpType",
            streamin,
          );
          encodable.fwdMarkupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 121: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.spotMarkupValue = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 122: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.tradesCount = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 123: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.clientTraderId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 124: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.lastOwnerGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 127: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientSegment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 128: {
          /*Object encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.clientIsTraderVisible = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 129: {
          /*Object encoding*/
          let val: CubiqTS.CounterPartyDetails = this.baseEncoder.readObject(
            true,
            false,
            "CounterPartyDetailsImpl",
            streamin,
          );
          encodable.counterPartyDetails = <CubiqTS.CounterPartyDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 130: {
          /*Object encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.clientStraightThroughProcessing = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 131: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.siLockUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 132: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.isLoopActiveLeg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 133: {
          /*Object encoding*/
          let val: CubiqTS.StrategyType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.StrategyType",
            streamin,
          );
          encodable.strategyType = <CubiqTS.StrategyType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 134: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientBranchCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 135: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 136: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.baseCurrencyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 137: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.nonBaseCurrencyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 138: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.lastSalesGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 139: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.lastClientBranchCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 140: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.lastBaseCurrencyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 141: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.lastNonBaseCurrencyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 142: {
          /*Object encoding*/
          let val: Array<CubiqTS.CustomValueImpl> = this.baseEncoder.readObject(
            false,
            true,
            "Array",
            streamin,
          );
          encodable.customValues = <Array<CubiqTS.CustomValueImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 143: {
          /*Object encoding*/
          let val: Array<CubiqTS.AllocationDataImpl> = this.baseEncoder.readObject(
            false,
            true,
            "Array",
            streamin,
          );
          encodable.allocationData = <Array<CubiqTS.AllocationDataImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 144: {
          /*Object encoding*/
          let val: CubiqTS.FixingDataImpl = this.baseEncoder.readObject(
            true,
            false,
            "FixingDataImpl",
            streamin,
          );
          encodable.fixingDetails = <CubiqTS.FixingDataImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 145: {
          /*Object encoding*/
          let val: CubiqTS.PauseState = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.PauseState",
            streamin,
          );
          encodable.pauseState = <CubiqTS.PauseState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 146: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.reqMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 147: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.MarkUpType",
            streamin,
          );
          encodable.reqMarginType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 148: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.orderRevisionId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 149: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            OrderDataImplEncoder.fidTypeMap.get(149),
            streamin,
          );
          encodable.ownerGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 150: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            OrderDataImplEncoder.fidTypeMap.get(150),
            streamin,
          );
          encodable.lastOwnerGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 151: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            OrderDataImplEncoder.fidTypeMap.get(151),
            streamin,
          );
          encodable.currencyPairIds = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 152: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientBranchHubCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 153: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientBranchHubName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 154: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.fillUserCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 155: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.fillUserName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 156: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.traderGroupName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 157: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.salesGroupNm = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 158: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.traderGroupBranchCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 159: {
          /*Primitive encoding*/
          let val: boolean = <boolean>(
            this.baseEncoder.readObject(false, false, "boolean", streamin)
          );
          encodable.isAggregateFillFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 160: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.filledBaseAmt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 161: {
          /*Object encoding*/
          let val: Array<CubiqTS.BenchmarkVisibilityPairAndOwnerImpl> = this.baseEncoder.readObject(
            false,
            true,
            OrderDataImplEncoder.fidTypeMap.get(161),
            streamin,
          );
          encodable.currencyPairAndOwners = <Array<CubiqTS.BenchmarkVisibilityPairAndOwnerImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 162: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.algoProfileId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 163: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.entryUserNm = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 164: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.clientBookingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 165: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.accountBookingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 166: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameterImpl> = this.baseEncoder.readObject(
            false,
            true,
            "Array",
            streamin,
          );
          encodable.passthroughParameters = <Array<CubiqTS.StrategyParameterImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 167: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.externalMarketRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 168: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.stpAggregationEnabled = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 169: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.alternateAccountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 170: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.modifyInAcceptanceFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 171: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.detFillMarketRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 172: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.detFillFwdPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 173: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.detFillNdfHorizonPts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 174: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.detFillTradeableFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 175: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.detFillHorizonPtsTradeableFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 176: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.alternateClientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 177: {
          /*Object encoding*/
          let val: CubiqTS.InflightInclusionState = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.InflightInclusionState",
            streamin,
          );
          encodable.inflightInclusionState = <CubiqTS.InflightInclusionState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 178: {
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.creditRejectCd = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 179: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.oboClient = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 180: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 181: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.strategyRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 182: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.orderRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 183: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.oboEntryUser = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 184: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.oboLockUser = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 185: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.oboCancelUser = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 186: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            OrderDataImplEncoder.fidTypeMap.get(186),
            streamin,
          );
          encodable.modifyUsers = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 187: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.insidePrevisibilityFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 188: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(true, false, "Errors", streamin);
          encodable.inboxReason = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 189: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.inboxOpsId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 190: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.nettingId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 191: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(false, false, "boolean", streamin);
          encodable.autoForwardPricingFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 192: {
          /*Object encoding*/
          let val: CubiqTS.HedgingModeType = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.HedgingModeType",
            streamin,
          );
          encodable.hedgingMode = <CubiqTS.HedgingModeType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 193: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.hedgingRuleId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 194: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.reqQuoteId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 195: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.fillNowOrderAmt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 196: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.marketVwapSpotRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 197: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            "java.math.BigDecimal",
            streamin,
          );
          encodable.marketVwapAllInRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 198: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.fwdNettingId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 199: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            "com.bcdfx.model.Tenor",
            streamin,
          );
          encodable.adjustedSettleTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 200: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            "java.util.Date",
            streamin,
          );
          encodable.previousFixingDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 201: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            "java.lang.Long",
            streamin,
          );
          encodable.previousTraderVisibilityOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case OrderDataImplEncoder.FID__CANCEL_DTS: {
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OrderDataImplEncoder.fidTypeMap.get(OrderDataImplEncoder.FID__CANCEL_DTS),
            streamin,
          );
          encodable.cancelDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(false, false, "java.lang.String", streamin);
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010: {
          /*Object encoding*/
          let val_10010:string=this.baseEncoder.readObject(false,false,OrderDataImplEncoder.fidTypeMap.get(10010),streamin);
          encodable.sessionOnly=val_10010;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return OrderDataImplEncoder.fidTypeMap.has(fid);
  }
}
